export default __webpack_public_path__ + "static/media/Pastry-Feijao-2.32b42972.jpg";